import { createGlobalStyle } from 'styled-components';

import SourceSansProBold from '@/assets/fonts/source-sans-pro-bold.woff';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'SourceSansProBold';
    src: url(${SourceSansProBold});
    font-weight: bold;
    font-style: normal;
  }
  
  .generated-images-holder-var21 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var21 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
    
  }

  .image-var21 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }

  .text-var21 {
    position: absolute;
    width: 100%;
    padding: 0 20px;
    bottom: 38px;
    font-size: 55px;
    line-height: 1.2;
    text-align: center;
    color: #fff;
    font-family: SourceSansProBold;
    p {
      border: solid 12px white;
      background-color: rgba(0,0,0,0.4);
      display: inline-block;
      margin: 0;
      padding: 8px 33px 9px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: calc(50% - 6px);
      width: 12px;
      height: 400px;
      background: white;
    }
    &:after {
      content: "";
      position: absolute;
      bottom: 100%;
      left: calc(50% - 6px);
      width: 12px;
      height: 600px;
      background: white;
    }
  }
  
  
  .left-actual-photo-var21 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .left-actual-photo-var21--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo-var21 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo-var21--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
